import { render, staticRenderFns } from "./cancel-premium.vue?vue&type=template&id=c13cce3e&scoped=true&"
import script from "./cancel-premium.vue?vue&type=script&lang=js&"
export * from "./cancel-premium.vue?vue&type=script&lang=js&"
import style0 from "./cancel-premium.vue?vue&type=style&index=0&id=c13cce3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13cce3e",
  null
  
)

export default component.exports